import React, { useState, useEffect } from 'react';

const InlineEditorWrapper = (props) => {
    const [isEditing, setEditing] = useState(props.isNew);

    useEffect(() => {
        window.addEventListener('inlineEdit', inlineEditEventHandler);
        return () => {
            window.removeEventListener('inlineEdit', inlineEditEventHandler);
        }
    }, []);

    useEffect(() => {
        if (!props.isNew) {
            setEditing(false);
        }
    }, [props.children]);

    function inlineEditEventHandler() {
            setEditing(false);
    }

    const viewer = React.cloneElement(
        props.children[0],
        {
            isEdit: isEditing,
            editItem: () => {
                dispatchEvent(new Event('inlineEdit'));
                setEditing(true);
            },
            ...props.children[0].props
        });

    const editor = React.cloneElement(
        props.children[1],
        {
            isEdit: isEditing,
            cancelEdit: () => setEditing(false),
            ...props.children[1].props
        });

    return (isEditing ? editor : viewer);
}

InlineEditorWrapper.defaultProps = {
    isNew: false
}

export default InlineEditorWrapper;